import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardPage from "../Modules/Dashboard/View/DashboardView";
import ReportPage from "../Modules/Dashboard/View/ReportView";
import CustomerList from "../Modules/Customer/View/CustomerList";
import AssetList from "../Modules/Asset/View/AssetList";
import PartsList from "../Modules/Parts/View/PartsList";
import PartsListMobile from '../Modules/Parts/View/PartsListMobile';
import PartDetailMobile from '../Modules/Parts/View/PartDetailMobile';
import SupplierList from "../Modules/Supplier/View/SuppliersList";
import QuotationsList from "../Modules/Quotation/View/QuotationList";
import SaleOrderList from '../Modules/SaleOrder/View/SaleOrderList';
import InvoiceList from '../Modules/Invoice/View/InvoiceList';
import PurchasingList from '../Modules/Purchasing/View/PurchasingList';
import AgreementList from '../Modules/Agreement/View/AgreementList';
import JobsList from '../Modules/Jobs/View/JobsList';
import JobsListMobile from '../Modules/Jobs/View/JobsListMobile';
import JobDetailMobile from '../Modules/Jobs/View/JobDetailMobile';
import CreateJobCommentsMobile from '../Modules/Jobs/View/JobForms/CreateJobCommentsMobile';
import JobDetail from '../Modules/Jobs/View/JobDetail';
import DiariesList from '../Modules/Diaries/View/DiariesList';
import Layout from "../Modules/Layout/Layout";
import Login from "../Modules/Auth/Views/Login";
import VerifyOtp from "../Modules/Auth/Views/VerifyOtp";

import ForgetPassword from "../Modules/Auth/Views/ForgetPassword";
import ResetPassword from "../Modules/Auth/Views/ResetPassword";
import Unauthorized from "../Modules/Setup/views/Unauthorized";
import ClientList from "../Modules/SuperAdmin/View/Client/CompanyList";
import AssignModule from "../Modules/SuperAdmin/View/AssignModules/AssignModule";
import CreateAssignModule from "../Modules/SuperAdmin/View/AssignModules/CreateAssignModule";
import AssignedForms from "../Modules/SuperAdmin/View/AssignedForms/AssignedForms";
import CreateAssignForm from "../Modules/SuperAdmin/View/AssignedForms/CreateAssignForm";
import NotFound from '../Modules/Setup/views/NotFound';  // Import the NotFound component
import CreateCustomer from "../Modules/Customer/View/CreateCustomer";
import SupplierDetail from "../Modules/Supplier/View/SupplierDetail";
import AssetDetail from "../Modules/Asset/View/AssetDetail";
import Configuration from "../Modules/SuperAdmin/View/Configuration/HelpLink";
import HelpSiteListPage from "../Modules/SuperAdmin/View/Configuration/HelpSiteList";
import PartDetail from "../Modules/Parts/View/PartsDetail";
import AgreementDetailPage from "../Modules/Agreement/View/AgreementDetail";
import AdministrationSetting from "../Modules/Setup/views/UserSetting/Administration";
import QuotationDetail from "../Modules/Quotation/View/QuotationDetail";
import FormRolePage from "../Modules/Setup/views/FormRole/FormRole";
import CustomerContactListPage from "../Modules/Customer/View/CustomerForms/CustomerContactList";
import LeadListPage from "../Modules/Lead/Views/LeadList";
import OpportunityListPage from "../Modules/Oppurtunity/Views/OpportunityList";
import { SidebarProvider } from '../Modules/Layout/SidebarContext';
import { ThemeProvider } from '../Modules/Layout/Theme/ThemeContext'; // Assuming ThemeContext is located here
import PrivateRoute from './PrivateRoute ';

import IssuePriorityList from "../Modules/SuperAdmin/View/IssuePriority/IssuePriorityList";
import IssueStatusList from "../Modules/SuperAdmin/View/IssueStatus/IssueStatusList";
import ReportList from "../Modules/Setup/views/Report/ReportList";
import ClientApiList from "../Modules/Setup/views/ClientApi/ClientApiList";
function
  routsConfig() {
  return (
    <Router>
      <ThemeProvider>
        <SidebarProvider>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/VerifyOtp" element={<VerifyOtp />} />
           

            <Route exact path="/ForgetPassword" element={<ForgetPassword />} />
            <Route exact path="/ResetPassword" element={<ResetPassword />} />

            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/Dashboard" element={<PrivateRoute element={DashboardPage} />} />
                    <Route path="/Report" element={<PrivateRoute element={ReportPage} />} />
                    <Route path="/AdministrationSetting" element={<AdministrationSetting />} />
                    <Route path="/CustomerList" element={<PrivateRoute element={CustomerList} />} />
                    <Route path="/CreateCustomer" element={<CreateCustomer />} />
                    <Route path="/SupplierList" element={<SupplierList />} />
                    <Route path="/SupplierDetail" element={<SupplierDetail />} />
                    <Route path="/AssetList" element={<AssetList ClientCompanyID={parseInt("0")} />} />
                    <Route path="/AssetDetail" element={<AssetDetail />} />
                    <Route path="/Configuration" element={<Configuration />} />
                    <Route path="/PartList" element={<PartsList />} />
                    <Route path="PartDetail" element={<PartDetail />} />
                    <Route path="/PartsListMobile" element={<PartsListMobile />} />
                    <Route path="/PartDetailMobile" element={<PartDetailMobile />} />
                    <Route path="/QuotationsList" element={<QuotationsList ClientCompanyID={parseInt("0")} LeadID={parseInt("0")} OpportunityID={parseInt("0")} MainPage={parseInt("1")} />} />
                    <Route path="/QuotationDetail" element={<QuotationDetail />} />
                    <Route path="/SaleOrderList" element={<SaleOrderList ClientCompanyID={parseInt("0")} />} />
                    <Route path="/InvoiceList" element={<InvoiceList ClientCompanyID={parseInt("0")} />} />
                    <Route path="/PurchasingList" element={<PurchasingList ClientCompanyID={parseInt("0")} SupplierID={parseInt("0")} />} />
                    <Route path="/AgreementList" element={<AgreementList ClientCompanyID={parseInt("0")} />} />
                    <Route path="/AgreementDetail" element={<AgreementDetailPage />} />
                    <Route path="/JobsList" element={<JobsList CustomerID={parseInt("0")} AssetID={parseInt("0")} StockID={parseInt("0")} ContractID={parseInt("0")} />} />
                    <Route path="/JobsListMobile" element={<JobsListMobile CustomerID={parseInt("0")} AssetID={parseInt("0")} StockID={parseInt("0")} ContractID={parseInt("0")} />} />
                    <Route path="/JobDetailMobile" element={<JobDetailMobile JobID={parseInt("0")} CustomerID={parseInt("0")} engineersData={[]} />} />
                    <Route path="/CreateJobCommentsMobile" element={<CreateJobCommentsMobile JobID={parseInt("0")} />} />
                    <Route path="/JobDetail" element={<JobDetail />} />
                    <Route path="/DiariesList" element={<DiariesList />} />
                    <Route path="/ClientList" element={<ClientList />} />
                    <Route path="/AssignModule" element={<AssignModule />} />
                    <Route path="/CreateAssignModule" element={<CreateAssignModule />} />
                    <Route path="/AssignedForms" element={<AssignedForms />} />
                    <Route path="/CreateAssignForm" element={<CreateAssignForm />} />
                    <Route path="/FormRole" element={<FormRolePage />} />
                    <Route path="/HelpSiteListPage" element={<HelpSiteListPage />} />
                    <Route path="/ContactList" element={<CustomerContactListPage ClientCompanyID={parseInt("0")} />} />
                    <Route path="/LeadList" element={<LeadListPage />} />
                    <Route path="/OpportunityList" element={<OpportunityListPage />} />

                    <Route path="/IssuePriorityList" element={<IssuePriorityList />} />
                    <Route path="/IssueStatusList" element={<IssueStatusList />} />
                    <Route path="/JasperReportList" element={<ReportList />} />
                    <Route path="/ClientApiList" element={<ClientApiList />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/Unauthorized" element={<Unauthorized />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </SidebarProvider>
      </ThemeProvider>
    </Router>
  );
}

export default routsConfig;
